import { QueryClient } from '@tanstack/react-query'

const ONE_MINUTE = 1000 * 60

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 10 * ONE_MINUTE,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
      retry: (failureCount, error: unknown) => {
        if (failureCount > 2) {
          return false
        }

        // Avoid retrying on 401/403 to prevent loops
        if (typeof error === 'object' && error !== null && 'response' in error) {
          const status = (error as { response?: { status?: number } }).response?.status
          if (status === 401 || status === 403) {
            return false
          }
        }

        return true
      },
    },
    mutations: {
      retry: 0,
    },
  },
})
